class MovingObject {
  constructor(options) {
    this.game = options.game;
  }

  draw(context) {
  }

  move() {
  }

  remove() {
    this.game.remove(this);
  }
}

module.exports = MovingObject;



//////////////////
// WEBPACK FOOTER
// ./lib/moving_object.js
// module id = 1
// module chunks = 0